import moment from "moment";

 export const getDateValue = (
        values: Record<string, string>[],
        dateFieldId: number,
        type: string
    ): string | undefined => {
        if (!Array.isArray(values)) {
            return undefined;
        }

        const dates = values
            .map(
                (item) =>
                    item?.[String(dateFieldId)]
            )
            .filter(Boolean)
            .map((date) =>
                moment(
                    date,
                    "DD-MM-YYYY",
                    true
                ).locale("en")
            )
            .filter((date) =>
                date.isValid()
            );

        if (!dates.length) {
            return undefined;
        }


        if (type === "Last") {
            return dates
                .reduce((latest, current) =>
                    current.isAfter(latest)
                        ? current
                        : latest
                )
                .locale("en").format("DD-MM-YYYY");
        }


        if (type === "Future") {
            const futureDates = dates.filter(
                (date) =>
                    date.isAfter(
                        moment(),
                        "day"
                    )
            );

            if (!futureDates.length) {
                return undefined;
            }

            return futureDates
                .reduce((latest, current) =>
                    current.isAfter(latest)
                        ? current
                        : latest
                )
                .locale("en").format("DD-MM-YYYY");
        }

        return dates
            .reduce((earliest, current) =>
                current.isBefore(earliest)
                    ? current
                    : earliest
            )
            .format("DD-MM-YYYY");
    };


   export const getDateByRadio = (
        values: Record<string, string>[],
        radioField: any,
        radioOptionKey: string,
        dateFieldId: number,
        type: string
    ): string | undefined => {
        if (
            !radioField ||
            !Array.isArray(values)
        ) {
            return undefined;
        }

        const radioOptionId =
            radioField?.InverseParentStepFields?.find(
                (item: any) =>
                    item?.Key ===
                    radioOptionKey
            )?.Id;

        if (radioOptionId === undefined) {
            return undefined;
        }


        const dates = values
            .filter(
                (item) =>
                    Number(
                        item?.[
                        String(radioField.Id)
                        ]
                    ) ===
                    Number(radioOptionId)
            )
            .map(
                (item) =>
                    item?.[String(dateFieldId)]
            )
            .filter(Boolean)
            .map((date) =>
                moment(
                    date,
                    "DD-MM-YYYY",
                    true
                ).locale("en")
            )
            .filter((date) =>
                date.isValid()
            );

        if (!dates.length) {
            return undefined;
        }


        if (type === "Last") {
            return dates
                .reduce((latest, current) =>
                    current.isAfter(latest)
                        ? current
                        : latest
                )
                .format("DD-MM-YYYY");
        }

        if (type === "Future") {
            const futureDates = dates.filter(
                (date) =>
                    date.isAfter(
                        moment(),
                        "day"
                    )
            );

            if (!futureDates.length) {
                return undefined;
            }

            return futureDates
                .reduce((latest, current) =>
                    current.isAfter(latest)
                        ? current
                        : latest
                )
                .format("DD-MM-YYYY");
        }


        return dates
            .reduce((earliest, current) =>
                current.isBefore(earliest)
                    ? current
                    : earliest
            )
            .format("DD-MM-YYYY");
    };
